import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { AlertDialog, AlertNotification, theme } from 'src/ui'
import {
  Signup,
  Login,
  LoginMfa,
  Navbar,
  Dashboard,
  PageNotFound,
  UserManagement,
  Profile,
  Wallets,
  Security,
  Orders,
  ResetPassword,
  ConfirmEmailVerification,
  PaymentMethods,
  ApiOnboard,
  Mint,
  Burn
} from 'src/pages'
import ScrollToTop from './ScrollToTop'
import RequireAuth from './RequireAuth'
import { AppContextProvider } from 'src/common/context'
import { CustomRouter } from './CustomRouter'
import { history } from './history'
import { Box } from '@mui/system'

const AppRoutes: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AlertDialog />
      <AlertNotification />
      <AppContextProvider>
        <CustomRouter history={history}>
          <ScrollToTop />
          <Routes>
            <Route
              element={
                <Box flex="1 0 auto">
                  <Navbar />
                  <Outlet />
                </Box>
              }
            >
              <Route
                path="/mfa"
                element={
                  <RequireAuth authType="guest">
                    <LoginMfa />
                  </RequireAuth>
                }
              />
              <Route
                index
                element={
                  <RequireAuth authType="protected">
                    <Dashboard />
                  </RequireAuth>
                }
              />
              <Route
                path="/orders"
                element={
                  <RequireAuth authType="protected">
                    <Orders />
                  </RequireAuth>
                }
              />
              <Route
                path="/mint"
                element={
                  <RequireAuth authType="protected">
                    <Mint />
                  </RequireAuth>
                }
              />
              <Route
                path="/burn"
                element={
                  <RequireAuth authType="protected">
                    <Burn />
                  </RequireAuth>
                }
              />
              <Route
                path="/signup"
                element={
                  <RequireAuth authType="guest">
                    <Signup />
                  </RequireAuth>
                }
              />
              <Route
                path="/signup/api"
                element={
                  <RequireAuth authType="guest">
                    <ApiOnboard />
                  </RequireAuth>
                }
              />
              <Route
                path="/login"
                element={
                  <RequireAuth authType="guest">
                    <Login />
                  </RequireAuth>
                }
              />
              <Route
                path="/reset-password"
                element={
                  <RequireAuth authType="guest">
                    <ResetPassword />
                  </RequireAuth>
                }
              />
              <Route
                path="/email-verification"
                element={
                  <RequireAuth authType="guest">
                    <ConfirmEmailVerification />
                  </RequireAuth>
                }
              />
              <Route
                path="/wallets"
                element={
                  <RequireAuth authType="protected">
                    <Wallets />
                  </RequireAuth>
                }
              />
              <Route
                element={
                  <RequireAuth authType="protected">
                    <UserManagement />
                  </RequireAuth>
                }
              >
                <Route path="/profile" element={<Profile />} />
                <Route path="/payment" element={<PaymentMethods />} />
                <Route path="/security" element={<Security />} />
              </Route>
            </Route>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </CustomRouter>
      </AppContextProvider>
    </ThemeProvider>
  )
}

export default AppRoutes
